// src/pages/Competitions/components/CompetitionsFiltersBar.jsx
import React from "react";
import { FaDownload, FaFilter, FaSearch, FaTimes } from "react-icons/fa";

const INPUT =
  "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:border-indigo-500 dark:focus:ring-indigo-950";

export default function CompetitionsFiltersBar({
  q = "",
  setQ,
  status = "all",
  setStatus,
  organizerFilter = "all",
  setOrganizerFilter,
  organizerOptions = [],
  onlyActive = false,
  setOnlyActive,
  onlyPublic = false,
  setOnlyPublic,
  sort = "date_desc",
  setSort,
  onExport,
  onResetFilters,
}) {
  return (
    <section className="rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-5">
      <div className="mb-4 flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-indigo-50 px-3 py-1 text-xs font-bold uppercase tracking-wide text-indigo-700 dark:bg-indigo-950/70 dark:text-indigo-300">
            <FaFilter />
            Filtres
          </div>

          <h2 className="mt-2 text-xl font-bold text-slate-900 dark:text-white">
            Rechercher une compétition
          </h2>
        </div>

        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={onExport}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-indigo-600 px-4 py-2.5 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-indigo-700"
          >
            <FaDownload />
            Export CSV
          </button>

          <button
            type="button"
            onClick={onResetFilters}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-100 px-4 py-2.5 text-sm font-bold text-slate-700 transition hover:-translate-y-0.5 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700"
          >
            <FaTimes />
            Réinitialiser
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 lg:grid-cols-12">
        <div className="relative lg:col-span-4">
          <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            type="search"
            value={q}
            onChange={(event) => setQ(event.target.value)}
            placeholder="Nom, lieu, niveau, discipline, organisateur..."
            className={`${INPUT} pl-11`}
          />
        </div>

        <select
          value={status}
          onChange={(event) => setStatus(event.target.value)}
          className={`${INPUT} lg:col-span-2`}
        >
          <option value="all">Toutes les périodes</option>
          <option value="past">Passées</option>
          <option value="todayup">Aujourd’hui & à venir</option>
          <option value="upcoming">Uniquement à venir</option>
        </select>

        <select
          value={organizerFilter || "all"}
          onChange={(event) => setOrganizerFilter?.(event.target.value)}
          className={`${INPUT} lg:col-span-3`}
        >
          {(Array.isArray(organizerOptions) && organizerOptions.length > 0
            ? organizerOptions
            : [{ value: "all", label: "Tous les organisateurs" }]
          ).map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        <select
          value={sort}
          onChange={(event) => setSort(event.target.value)}
          className={`${INPUT} lg:col-span-3`}
        >
          <option value="date_desc">Date décroissante</option>
          <option value="date_asc">Date croissante</option>
          <option value="name_az">Nom A → Z</option>
          <option value="name_za">Nom Z → A</option>
        </select>
      </div>

      <div className="mt-4 flex flex-wrap items-center gap-3">
        <TogglePill
          active={onlyActive}
          onClick={() => setOnlyActive(!onlyActive)}
          label="Actives uniquement"
        />

        <TogglePill
          active={onlyPublic}
          onClick={() => setOnlyPublic(!onlyPublic)}
          label="Publiques uniquement"
        />
      </div>
    </section>
  );
}

function TogglePill({ active, onClick, label }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-3 rounded-2xl px-4 py-2.5 text-sm font-bold transition ${
        active
          ? "bg-emerald-600 text-white hover:bg-emerald-700"
          : "bg-slate-100 text-slate-700 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700"
      }`}
    >
      <span
        className={`flex h-5 w-9 items-center rounded-full p-0.5 transition ${
          active ? "bg-white/30" : "bg-slate-300 dark:bg-slate-700"
        }`}
      >
        <span
          className={`h-4 w-4 rounded-full bg-white shadow transition ${
            active ? "translate-x-4" : "translate-x-0"
          }`}
        />
      </span>
      {label}
    </button>
  );
}
